import { useTranslation } from 'react-i18next';
import { useTheme } from '@/lib/theme/theme-context';

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  const isDark = theme === 'dark';

  const toggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark');
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={isDark ? t('theme.light') : t('theme.dark')}
      aria-label={t('theme.label')}
      className="flex h-10 w-10 items-center justify-center glass rounded-full text-fg-2 transition-all hover:text-fg-1 sm:h-8 sm:w-8"
    >
      {isDark ? (
        <span className="text-14 leading-none" role="img" aria-hidden="true">
          ☀️
        </span>
      ) : (
        <span className="text-14 leading-none" role="img" aria-hidden="true">
          🌙
        </span>
      )}
    </button>
  );
}
